/**
 * Created by akirilyuk on 11/24/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/widgets/datetimepickerbubbleview.tmpl"),
        slider = require("jqueryui/slider"),
        DateTimePicker = require("connection-views/ticketTab/widgets/DateTimePicker"),
        DateTimePickerBubbleView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        DateTimePickerBubbleView = Marionette.CompositeView.extend({
                template: template,
                className: 'date-time-picker-bubble-view',
                ui: {
                    dateTimePickerContainer: ".date-time-picker-container"
                },
                uiComponents: {
                    dateTimePicker: {
                        type: DateTimePicker,
                        options: {
                            el: "view.ui.dateTimePickerContainer",
                            limitToNow: true,
                            initialDate: "view._getInitDate"
                        }
                    }
                },
                events: {
                    "clickoutside": "_onClickOutside"
                },

                initialize: function(options){
                    this.channel = options.channel;
                    this.initDate = options.initDate;
                },

                onRender: function () {
                    this.listenTo(this.uiComponents.dateTimePicker, DateTimePicker.TRIGGERING.DONE_CLICKED, this._onDateSelected);
                    this.listenTo(this.uiComponents.dateTimePicker, DateTimePicker.TRIGGERING.NOW_CLICKED, this._onDateSelected);
                },

                _onDateSelected: function () {
                    this.channel.vent.trigger("date::selected",this.uiComponents.dateTimePicker.getDate());
                },

                _onClickOutside: function (element) {
                    this.channel.vent.trigger("clicked::outside",element);
                },

                _getInitDate: function(){
                    return this.initDate;
                }
            }
        );
    });
    return DateTimePickerBubbleView;
});
